import React from "react";
import ErrorFeedbackBar from "../global/ErrorFeedbackBar";
import {ADD_EMPLOYEE_SESSION, EMPLOYEE_SESSION, EMPLOYEE_SESSION_PAGES, ROWS_PER_PAGE} from "./constants";
import FeedbackBar from "../feedbackBar/FeedbackBar";
import withShipment from "../../withShipment";
import {statusSelector} from "../../redux/selectors/global";
import {clearStatus} from "../../redux/actions/global";
import {employeesSelector, userInfoSelector} from "../../redux/selectors/auth";
import EmployeeSessionTable from "./EmployeeSessionTable";
import {
    deleteEmployeeSession,
    listEmployeeSession,
    manualClockIn,
    updateEmployeeStatus
} from "../../redux/actions/settings";
import {employeeSessionSelector} from "../../redux/selectors/settings";
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import CustomToolbar from "../global/CustomToolbar";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {getPDFPreview, resetPdfPreviewData} from "../../redux/actions/ticketOut";
import {PDFpreviewReadySelector} from "../../redux/selectors/ticketOut";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EmployeeSessionForm from "./EmployeeSessionForm";
import {getEmployees} from "../../redux/actions/auth";
import ReportList from "./ReportsView";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';

class EmployeeSession extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: EMPLOYEE_SESSION_PAGES.TABLE,
            feedbackBarOpen: false,
            error: false,
            feedbackStatus: '',
            feedbackMessage: '',
            fromDate: this.getFromDate(),
            toDate: this.getToDate(),
            fetchedList: true,
            page: 0,
            rowsPerPage: ROWS_PER_PAGE,
            searchText: '',
            selecting: false,
            selectedEntries: {},
            employeeSession: [],
            editEmployeeSession: null,
            beforeEditRow: null,
            editingRowIndex: null,
            isHideMainToolbar: false,
            isBack: false,
            selectedName: null,
        }
    }

    componentDidMount() {
        this.props.getEmployees({locationId: this.props.user.selectedLocationId})
    }



    handleEditingClear = () => {
        this.setState({ editEmployeeSession: null, isHideMainToolbar: false }, () => {
            this.setCurrentPage(EMPLOYEE_SESSION_PAGES.TABLE, {})
        })
    }

    handleEditRow = (employee) => {
        this.setState({ isHideMainToolbar: true, editEmployeeSession: employee }, () => {
            this.setCurrentPage(EMPLOYEE_SESSION_PAGES.FORM, {})
        })
    }

    fetchEmployeeSessions = (fromDate, toDate) => {
        this.props.listEmployeeSession({
            fromDate: fromDate,
            toDate:  toDate,
            locationId: this.props.user.selectedLocationId
        })
    }

    setFetchedList = (fetched) => {
        this.setState({
            fetchedList: fetched
        })
    }

    setPage = (page) => {
        this.setState({
            page: page
        })
    }


    componentDidUpdate(prevProps, prevState) {
        if (this.props.status.statusText && prevProps.status.statusText !== this.props.status.statusText) {
            this.openFeedbackBar(this.props.status.statusText, 'error');
        }

        if (prevProps.employeeSession !== this.props.employeeSession) {
            this.setState({
                employeeSession: this.props.employeeSession,
                editingRowIndex: null,
            })
        }


    }

    setRowsPerPage = (rowsPerPage) => {
        this.setState({
            rowsPerPage: rowsPerPage
        })
    }

    handleDateChange = (date, key) => {
        this.setState({
            [key]: date
        })
    }

    handleSearchTextChange = (e) => {
        this.setState({
            searchText: e.target.value
        })
    }

    getFromDate = () => {
        const date = new Date();
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setDate(date.getDate() - 7)
        return date;
    }

    getToDate = () => {
        const date = new Date();
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
        return date;
    }

    displayForm = () => {
        return (
            <EmployeeSessionForm
                user={this.props.user}
                handleEditingClear={this.handleEditingClear}
                manualClockIn={this.props.manualClockIn}
                editEmployeeSession={this.state.editEmployeeSession}
                setCurrentPage={this.setCurrentPage}
                openFeedbackBar={this.openFeedbackBar}
                employees={this.props.employees}
            />
        )
    }


    setCurrentPage = (newPage) => {
        this.setState({
            currentPage: newPage
        })
    }

    displayReport = () => {
        return (
            <ReportList
              userInfo={this.props.user}
              onSelectReport={this.fetchPdf}
              employee={this.state.selectedEmployeeSession}
              handleEditingClear={this.handleEditingClear}/>
        )
    }


    displayTable= () => {

        return (
            <EmployeeSessionTable
                deleteEmployeeSession={this.props.deleteEmployeeSession}
                handleEmployeeEditRow={this.handleEditRow}
                user={this.props.user}
                fetchEmployeeSessions={this.props.listEmployeeSession}
                data={this.props.employeeSession}
                setCurrentPage={this.setCurrentPage}
                openFeedbackBar={this.openFeedbackBar}
                handleSearchChange={this.handleSearchTextChange}
                searchText={this.state.searchText}
                page={this.state.page}
                setPage={this.setPage}
                rowsPerPage={this.state.rowsPerPage}
                setRowsPerPage={this.setRowsPerPage}
                handleDateChange={this.handleDateChange}
                setFetchedList={this.setFetchedList}
                checkedEntries={this.state.selectedEntries}
                fromDate={this.state.fromDate}
                toDate={this.state.toDate}
                setBack={( isBack,selectedName) => {
                    this.setState({ isBack: isBack,selectedName :selectedName })
                }}
                 selectedName={this.state.selectedName}
                isBack={this.state.isBack}
                setSelected={(newEntries, selecting,selectedEmployeeSession) =>
                    this.setState({ selectedEntries: newEntries, selecting: selecting, selectedEmployeeSession: selectedEmployeeSession })
                }
            />
        )
    }


    changeStatus(status) {
        let clockIds = []
        Object.keys(this.state.selectedEntries).map(key => {
            if (this.state.selectedEntries[key]) {
                clockIds.push(key);
            }
            return null;
        })
        this.updateStatus(clockIds, status, () => window.location.reload())
    }

    updateStatus(clockIds, status, callback) {
        this.props.updateEmployeeStatus({ clockIds: clockIds, status: status }, callback,
            this.state.fromDate, this.state.toDate)

        this.setState(prevState => ({
            employeeSession: prevState.employeeSession.map(
                record => clockIds.includes(record.clockId)
                    ? { ...record, status: status }
                    : record
            )
        }))
    }

    displayCurrentPage = () => {
        switch (this.state.currentPage) {
            case EMPLOYEE_SESSION_PAGES.TABLE:
                return this.displayTable()
            case EMPLOYEE_SESSION_PAGES.FORM:
                return this.displayForm()
            case EMPLOYEE_SESSION_PAGES.REPORT:
                return this.displayReport()
            default:
                return <div>We encountered an error. Please refresh the page.</div>
        }
    }


    openFeedbackBar = (status, message) => {
        this.setState({ feedbackStatus: status, feedbackMessage: message, feedbackBarOpen: true });
    }

    closeFeedbackBar = () => {
        this.setState({ feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' }, () => {
            this.props.clearStatus();
        });
    }

    showPdfErrorMessage = (isFailed) => {
        this.props.resetPdfPreviewData();
        this.setState({ pdfLoadSuccess: !isFailed })
    }


    render() {

        let headerButtons = [];

           if (this.state.isBack) {
             headerButtons.push(
                    {
                        icon: <KeyboardBackspaceIcon />,
                        handler: () => this.setState({ isBack: false,selecting: false }),
                        title: "Back",
                    })

           }

        if (this.state.selecting) {
                headerButtons.push(
                    {
                        icon: <MoneyOffIcon />,
                        handler: () => this.changeStatus('Unpaid'),
                        title: "Mark as Unpaid",
                    },
                    {
                        icon: <AttachMoneyIcon />,
                        handler: () => this.changeStatus('Paid'),
                        title: "Mark as Paid",
                    },
                    {
                        icon: <VisibilityIcon />,
                        handler: () =>  {

                            this.setState({isHideMainToolbar: true},()=>{
                                this.setCurrentPage(EMPLOYEE_SESSION_PAGES.REPORT, {})
                            })

                        },
                        title: "View Report",
                    }
                );

        }else {
        headerButtons.push(
                    {
                        icon: <AddCircleIcon/>,
                        handler: () =>  {
                            this.setState({isHideMainToolbar: true},()=>{
                                this.setCurrentPage(EMPLOYEE_SESSION_PAGES.FORM, {})
                            })
                        },
                        title: ADD_EMPLOYEE_SESSION,
                    }
                )
        }

        return (

            <React.Fragment>
                <ErrorFeedbackBar/>
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    handleClose={this.closeFeedbackBar}
                    severity={this.state.feedbackStatus}
                    message={this.state.feedbackMessage}
                />

                {!this.state.isHideMainToolbar &&    <CustomToolbar
                    title={ EMPLOYEE_SESSION }
                    createTitle={""}
                    backTitle={""}
                    headerButtons={headerButtons}
                />}


                {this.displayCurrentPage()}

            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    status: statusSelector(state),
    user: userInfoSelector(state),
    employees: employeesSelector(state),
    employeeSession: employeeSessionSelector(state),
    PDFpreviewReady: PDFpreviewReadySelector(state),
})


const actionCreators = {
    clearStatus,
    listEmployeeSession,
    updateEmployeeStatus,
    getPDFPreview,
    resetPdfPreviewData,
    getEmployees,
    manualClockIn,
    deleteEmployeeSession
}

export default withShipment({
    actionCreators,
    mapStateToProps
}, EmployeeSession);